<template>
  <span v-if="!isClientePerfil && !ocultarEstoque">
    <b-badge
      :variant="info.variant"
      class="estoque-badge"
      :title="tooltipText"
      v-b-tooltip.hover
    >
      <feather-icon icon="PackageIcon" size="10" class="mr-25" />
      {{ info.label }}
    </b-badge>
    <small v-if="info.substituto" class="d-block text-muted mt-25" style="font-size:0.7rem">
      Subst: {{ info.substituto }}
      <span v-if="info.quantidadeSubstituto !== null">({{ info.quantidadeSubstituto }} un)</span>
    </small>
  </span>
</template>

<script>
import { BBadge, VBTooltip } from 'bootstrap-vue';
import SLSEstoqueService from '@/services/SistemaDKP/SLSEstoque.service';
import { isPerfilClienteAtivo } from '@/libs/perfilCliente';
import { ocultarEstoqueCertificacao, tipoPedidoSelecionadoParaEstoque } from '@/utils/estoqueVisibilidade';

export default {
  name: 'EstoqueBadge',
  components: { BBadge },
  directives: { 'b-tooltip': VBTooltip },
  props: {
    tipoPedidoId: {
      type: String,
      default: null,
    },
    estoqueInfo: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ocultarEstoque() {
      return ocultarEstoqueCertificacao(this.tipoPedidoId || tipoPedidoSelecionadoParaEstoque(this.$store));
    },
    isClientePerfil() {
      return isPerfilClienteAtivo();
    },
    info() {
      return SLSEstoqueService.formatarEstoque(this.estoqueInfo);
    },
    tooltipText() {
      if (!this.estoqueInfo) return 'Estoque não consultado';
      if (this.estoqueInfo.fonte === 'totvs') return 'Fonte: TOTVS (tempo real)';
      if (this.estoqueInfo.fonte === 'fallback') return 'Fonte: banco local (fallback)';
      if (this.estoqueInfo.fonte === 'certificacao') return 'Produto certificado — estoque ilimitado';
      return '';
    },
  },
};
</script>

<style scoped>
.estoque-badge {
  font-size: 0.72rem;
  cursor: default;
}
</style>
